import {
  createFileRoute,
  notFound,
  Outlet,
  redirect,
} from "@tanstack/react-router"

import { useOrganisationPalette } from "@/hooks/use-organisation-palette"
import { currentOrganisation, setOrganisation } from "@/lib/api/client"
import { isApiError } from "@/lib/api/errors"
import {
  forgetOrganisation,
  rememberOrganisation,
} from "@/lib/last-organisation"
import { organisationQueries } from "@/queries/organisations"

export const Route = createFileRoute("/$organisation")({
  beforeLoad: async ({ context, params, location, preload }) => {
    const entered = currentOrganisation()

    if (preload && entered !== params.organisation) {
      throw notFound()
    }

    if (entered !== null && entered !== params.organisation) {
      throw redirect({ href: location.href, reloadDocument: true })
    }

    try {
      const brand = await context.queryClient.ensureQueryData(
        organisationQueries.brand(params.organisation)
      )
      setOrganisation(brand.id)
      rememberOrganisation(brand.id)

      return { brand }
    } catch (error) {
      if (isApiError(error) && error.isNotFound) {
        forgetOrganisation(params.organisation)
        throw notFound()
      }

      throw error
    }
  },
  component: OrganisationAddress,
})

function OrganisationAddress() {
  const { brand } = Route.useRouteContext()
  useOrganisationPalette(brand.primaryColour)

  return <Outlet />
}
